import React from 'react';

const LoadingIndicator = ({ className = '', showText = false, text = "Thinking..." }) => {
  return (
    <div className={`flex items-center space-x-2 px-0 py-2 rounded-2xl max-w-xs ${className}`}>
      <img 
        src="/loading.gif" 
        alt="" 
        className="w-14 h-14"
      />
      {showText && (
        <span className="text-sm text-gray-500 dark:text-gray-400">{text}</span>
      )}
    </div>
  );
};

export default LoadingIndicator;
